import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { markInternalTraffic } from "../../lib/analytics";
import { postSession } from "../../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        await postSession(sessionId);
        window.history.replaceState(null, "", "/admin");
        markInternalTraffic();
        navigate("/admin", { replace: true });
      } catch (e) {
        navigate("/admin/login?error=unauthorized", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-background text-foreground font-body">
      Signing you in…
    </div>
  );
}
